import { createContext, useContext, useState } from 'react';

const RefundModalContext = createContext();

export function RefundModalProvider({ children }) {
  const [refundModal, openRefundModal] = useState(false);

  return (
    <RefundModalContext.Provider value={[refundModal, openRefundModal]}>
      {children}
    </RefundModalContext.Provider>
  );
}

export function useRefundModalContext() {
  return useContext(RefundModalContext);
}

const RefundAPICallContext = createContext();

export function RefundAPICallProvider({ children }) {
  const [refundAPICall, setRefundAPICall] = useState(false);

  return (
    <RefundAPICallContext.Provider value={[refundAPICall, setRefundAPICall]}>
      {children}
    </RefundAPICallContext.Provider>
  );
}

export function useRefundAPICallContext() {
  return useContext(RefundAPICallContext);
}
